import { useQuery } from '@tanstack/react-query';
import { gqlClient, graphql } from '@tyro/api';
import { shellKeys } from '../keys';

const notificationCount = graphql(/* GraphQL */ `
  query communications_notificationCount {
    communications_notificationCount {
      count
    }
  }
`);

export function useNotificationsUnreadCount() {
  return useQuery({
    queryKey: shellKeys.notifications.unreadCount(),
    queryFn: () => gqlClient.request(notificationCount),
    select: ({ communications_notificationCount }) =>
      communications_notificationCount?.count ?? 0,
    refetchInterval: 1000 * 60 * 2,
  });
}
